import { buttonVariants } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Toaster } from '@/components/ui/toaster';
import { cn } from '@/lib/utils';
import { Link } from 'lucide-react';
import React from 'react'
import { Outlet } from 'react-router-dom';

const BaseLayout = () => {
    return (
        <>
            <Outlet />
            <Toaster />
        </>
    )
}

export default BaseLayout;
